import http from '@/http'
import { Part } from '@/interfaces/admin/part'

export async function isPartNumberSuperseded (partNumber: string): Promise<boolean> {
  const { data } = await http.get(`/admin/draft-bom/superseded?partNumber=${partNumber}`)
  return data
}

export async function arePartNumbersSuperseded (partNumbers: string[]): Promise<string[]> {
  const { data } = await http.post(`/admin/draft-bom/superseded/list`, {partNumbers: partNumbers})
  return data
}

export async function getSupersedingParts (partNumber: string): Promise<Part[]> {
  const { data } = await http.get(`/admin/draft-bom/superseding-parts?partNumber=${partNumber}`)
  return data
}
